import { lazy } from 'react';
import { ICONS } from '../navigationIcons';

const AccountsPage = lazy(() => import('src/compass/pages/lrpTeam/AccountsPage'));
const ExternalScesPage = lazy(() => import('src/compass/pages/lrpTeam/ExternalScesPage'));
const SettingsPage = lazy(() => import('src/compass/pages/lrpTeam/SettingsPage'));

export const LrpTeamMenu = [
  {
    menuTitle: 'LRP Team',
    path: 'lrp-team',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Accounts',
        path: 'accounts',
        element: <AccountsPage />,
        permission: 'LRP_ACCOUNTS',
      },
      {
        title: 'External SCEs',
        path: 'externalsces',
        element: <ExternalScesPage />,
        permission: 'EXTERNAL_SCES',
      },
      {
        title: 'Settings',
        path: 'settings',
        element: <SettingsPage />,
        permission: 'LRP_SETTINGS',
      },
    ],
  },
];
